<script>
	import {docs} from "../store";
    import Controlador from '../controlador.svelte';
    import {onMount,beforeUpdate,afterUpdate} from "svelte";
	let c;
	export let params;
	let turno;
	let turnos = [];
	let empleados = [];
	let modo = 0;
    let meses = [
        "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE","DICIEMBRE"
    ];
    let coloresTexto = {
		"SM":"text-pink-500",
		"SF":"text-purple-500",
		"G":"text-blue-500",
		"C":"text-green-500"
	}
	let coloresFondo = [
		"bg-red-100",
		"bg-pink-100",
		"bg-orange-100",
		"bg-yellow-100",
		"bg-green-100",
		"bg-blue-100",
		"bg-purple-100",
		"bg-gray-100",
		"bg-red-200",
		"bg-pink-200",
		"bg-orange-200",
		"bg-yellow-200",
		"bg-green-200",
		"bg-blue-200",
		"bg-purple-200",
        "bg-gray-200",
        "bg-red-300",
		"bg-pink-300",
		"bg-orange-300",
		"bg-yellow-300",
		"bg-green-300",
		"bg-blue-300",
		"bg-purple-300",
		"bg-gray-300"
	]
    let obtenerNombres = [
        'Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'
    ];
    let nombresSemana = [];
    let dias = [];
    let cantidadDias = 0;
    let mes = 0;
    let ano = 2020;
    let botones = [
		{nombre:"Volver",icon:"ri-arrow-left-line",href:"#/home"},
	]
	onMount(()=>{
		empleados = $docs.filter((el)=>el._id.includes("empleado:"));
		if (params.id){
			empleados = empleados.filter((el)=> el._id == params.id);
		}
        mes = new Date().getMonth();
        ano = new Date().getFullYear();
		cantidadDias = diasEnUnMes(mes,ano);
	})
	beforeUpdate(()=>{
        if (turnos){
            turnos = $docs
            .filter((el)=>el._id.includes("turno:"))
            .filter((el)=> !el.cancelado)
			if (params.id){
				turnos = turnos.filter((el)=>el.idEmpleado == params.id);
			}
            console.log(turnos);
        }
        if (turnos){
            let actual = new Date();
            let fdia = new Date(ano,mes,1);
            let mesActual = new Date(ano,mes + 1,0).getMonth();
            nombresSemana = [];
            for (let i=0;i<=6;i++){
                let puntero = (fdia.getDay() + i) % 7;
                nombresSemana.push(obtenerNombres[puntero]);
            }
            dias = [];
            for (let i=0;i<cantidadDias;i++){
                let puntero = i % 7;
                let listaTurnos = [];
                turnos.forEach((t)=>{
                    let fecha = new Date(t.turno);
                    if (fecha.getMonth() == mes && fecha.getFullYear() == ano && fecha.getDate() == i + 1){
                        listaTurnos.push(t);
                    }
                })
                dias.push({nombre:nombresSemana[puntero],numero:i+1,turnos:listaTurnos});
            }
            dias = dias;
		}
		console.log(dias);
	})
	function diasEnUnMes(mes, año) {
        return new Date(año, mes, 0).getDate();
    }
    function siguiente(){
        if (mes < 11){
            mes += 1;
            cantidadDias = diasEnUnMes(mes+1,ano);
        } else {
            mes = 0;
            ano += 1;
            cantidadDias = diasEnUnMes(0,ano);
        }
        modo = 0;
	}
	function esHoy(dia){
		let hoy = new Date();
		let d = hoy.getDate();
		let m = hoy.getMonth();
		let y = hoy.getFullYear();
		if (mes == m && ano == y && d == dia){
			return 'font-bold text-xs text-white bg-red-500 rounded-full p-1';
		} else {
			return 'font-bold text-xs text-red-500 p-1';
		}
	}
    function reset(){
        mes = new Date().getMonth();
        ano = new Date().getFullYear();
        cantidadDias = diasEnUnMes(new Date().getMonth(),new Date().getFullYear());
        modo = 0;
    }
    function anterior(){
        if (mes > 0){
            mes -= 1;
            cantidadDias = diasEnUnMes(mes-1,ano);
        } else {
            mes = 11;
            ano -= 1;
            cantidadDias = diasEnUnMes(11,ano);
        }
        modo = 0;
	}
	function obtenerFondo(turno){
		let numero = empleados.findIndex((el)=>{return (el._id == turno.idEmpleado)});
		return coloresFondo[numero];
	}
	function seleccionar(t){
		console.log(t);
		turno = t;
		modo = 1;
	}
	function verHora(turno){
        let t = new Date(turno);
        return `${t.getHours()}:${t.getMinutes()}hs`;
	}
	function textoFecha(turno){
		let t = new Date(turno);
		let m = t.getMonth() + 1;
		let y = t.getFullYear();
		let d = t.getDate();
		let nombre = obtenerNombres[t.getDay()];
		return `El ${nombre} ${d}/${m}/${y} a las ${verHora(turno)}`;
	}
	function volver(){
		turno = undefined;
		modo = 0;
	}
	function verLink(){
		window.open(turno.link);
	}
</script>
{#if modo == 0}
<div class="p-4 w-screen max-w-full h-full flex flex-col items-center">
    <div class="w-full sm:w-3/4 flex items-center justify-between">
		{#each botones as b}
			<a href={b.href} class="w-1/3 m-2 text-xs md:text-md text-white p-2 bg-red-500 cursor-pointer flex items-center justify-center rounded shadow ">
				<i class={b.icon} />
				{b.nombre}
		</a>
		{/each}
	</div>
	<div class="w-full flex items-center justify-center p-2">
		<button on:click={anterior} class="flex items-center justify-center p-2 bg-red-500 text-white cursor-pointer hover:bg-red-300 rounded-l shadow">
			<i class="ri-arrow-left-line" />
		</button>
		<div on:click={reset} class="w-full cursor-pointer flex items-center justify-center font-bold p-2 bg-red-500 text-white hover:bg-red-300">{meses[mes]} {ano}</div>
		<button on:click={siguiente} class="flex items-center justify-center p-2 bg-red-500 text-white cursor-pointer hover:bg-red-300 rounded-r shadow">
			<i class="ri-arrow-right-line" />
		</button>
	</div>
</div>
<div class="w-full h-8 grid grid-cols-7 grid-rows-auto gap-px bg-gray-100 border-b border-gray-400">
	{#each nombresSemana as dia}
		<div class="w-full text-xs font-bold flex items-center justify-center" >{dia}</div>
	{/each}
</div>
<div class="w-full h-screen  grid grid-cols-7 grid-rows-auto gap-px">
	{#each dias as dia}
		<div class="w-full cursor-pointer h-full flex flex-col  items-start jusfity-center bg-white texto">
			<div class={`${esHoy(dia.numero)}`}>{dia.numero}</div>
			{#each dia.turnos as turno}
				{#if turno.tipo == "Nota"}
				<p on:click={()=>seleccionar(turno)} class={`bg-red-500 text-white w-full`}>{turno.abreviacion}-{turno.detalle}</p>
				{:else}
				<p on:click={()=>seleccionar(turno)} class={`${obtenerFondo(turno)} ${coloresTexto[turno.abreviacion]} cursor-pointer hover:bg-opacity-50 w-full`}>{turno.abreviacion} - {turno.empleado} - {verHora(turno.turno)}</p>
				{/if}
			{/each}
			
		</div>
	{/each}
</div>
{:else}
<div class="p-4 w-screen max-w-full h-full flex flex-col items-center">
	<button on:click={volver} class="w-full flex items-center justify-center p-2 bg-red-500 text-white cursor-pointer hover:bg-red-300 rounded shadow">
		<i class="ri-arrow-left-line" />
		Volver
	</button>
	<div class="w-full flex items-center justify-start m-2">{ textoFecha(turno.turno)}</div>
	<div class={`w-full flex items-center justify-start m-2 ${coloresTexto[turno.abreviacion]}`}><span class="font-bold">Sucursal: </span>{turno.local}</div>
	<div class="w-full flex items-center justify-start m-2"><span class="font-bold">Artista: </span>{turno.empleado}</div>
	<div class="w-full flex items-center justify-start m-2"><span class="font-bold">Cliente: </span>{turno.cliente}</div>
	<div class="w-full flex items-center justify-start m-2"><span class="font-bold">Detalle: </span>{turno.detalle}</div>
	{#if turno.sena}
		<div class="w-full flex items-center justify-start m-2"><span class="font-bold">Seña: </span>${turno.sena}</div>
	{/if}
	{#if turno.link}
		<div on:click={verLink} class="w-full flex items-center justify-center p-2 bg-red-500 text-white cursor-pointer hover:bg-red-300 rounded shadow"> Ver Imagen</div>
	{/if}
</div>
{/if}
<style>
	.texto{
		font-size:0.5rem;
	}
</style>
